module.exports = __webpack_public_path__ + "img/axl.689d9a76.svg";